import React, { useState } from 'react';
import { PlusOutlined } from '@ant-design/icons';
import { Button, Form, Input, Upload, message } from 'antd';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

const AdminCreateNotice = () => {
  const [fileList, setFileList] = useState([]);
  const [content, setContent] = useState('');
  const [form] = Form.useForm();
  
  const apiUrl = process.env.REACT_APP_API_URL;

  const handleFileChange = ({ fileList }) => setFileList(fileList);

  const handleSubmit = async (values) => {
    const { title } = values;
    const formData = new FormData();

    formData.append('content', content); // ReactQuill içeriğini ekliyoruz
    formData.append('title', title);

    if (fileList.length > 0) {
      formData.append('img', fileList[0].originFileObj);
    }

    try {
      const response = await fetch(`${apiUrl}/api/notice`, {
        method: 'POST',
        body: formData,
      });

      if (response.ok) {
        message.success('Duyuru başarıyla oluşturuldu');
        form.resetFields();
        setFileList([]);
        setContent(''); 
      } else {
        message.error('Bir hata oluştu');
      }
    } catch (error) {
      console.error('Error:', error);
      message.error('Bir hata oluştu');
    }
  };

  return (
    <Form
      form={form}
      labelCol={{ span: 4 }}
      wrapperCol={{ span: 14 }}
      layout="horizontal"
      onFinish={handleSubmit}
      style={{ maxWidth: 800, margin: '0 auto' }}
    >
      <Form.Item label="Başlık" name="title" rules={[{ required: true, message: 'Başlık alanı boş bırakılamaz!' }]}> 
        <Input />
      </Form.Item>

      <Form.Item label="Duyuru İçeriği" required>
        <ReactQuill 
          theme="snow"
          value={content}
          onChange={setContent}
          modules={{
            toolbar: [
              [{ 'header': '1' }, { 'header': '2' }, { 'font': [] }],
              [{ size: [] }],
              ['bold', 'italic','blockquote'],
              [{ 'list': 'ordered' }, { 'list': 'bullet' }],
              ['link'],
              ['clean']
            ],
          }}
        />
      </Form.Item>

      <Form.Item label="Resim" name="img">
        <Upload action="/upload.do" listType="picture-card" fileList={fileList} onChange={handleFileChange} beforeUpload={() => false}>
          <button style={{ border: 0, background: 'none' }} type="button">
            <PlusOutlined />
            <div style={{ marginTop: 8 }}>Yükle</div>
          </button>
        </Upload>
      </Form.Item>

      <Form.Item wrapperCol={{ offset: 4, span: 14 }}>
        <Button type="primary" htmlType="submit">
          Duyuru Oluştur
        </Button>
      </Form.Item>
    </Form>
  );
};

export default AdminCreateNotice;
